'use strict';

var Reflux = require('@muzzylane/reflux');

var SignUpActions = require('../actions/signup_actions'),
    ServerRequest = require('../actions/request'),
    ErrorConsts = require('../constants/error'),
    ForgeError = require('../util/error');
var SignInActions = require('../actions/sign_in_actions');

var initialized = false;
var action = {};
var error = null;

var SignUpStore = Reflux.createStore({
    listenables: [SignUpActions,SignInActions],
    init: function() {
        initialized = true;
    },

    resetState: function() {
        // initialized = false;
        // action = {};
        // error = null;
    },
    
    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },
    
    getState: function() {
        return {
            initialized: initialized,
            action: action
        }
    },

    emitStatus: function() {
        //console.log("template store: EMIT");
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    onSignUpFailed: function(actionID, err) {
        action = {};
        action.id = actionID;

        if(err.status){
            switch(err.status){
                case 409:
                case 422:
                    action.error = new ForgeError({message: ErrorConsts.EMAIL_ALREADY_REGISTERED});
                    break;
                case 400:
                    switch(err.responseText){
                        case 'INVALID_TOKEN':
                            action.error = new ForgeError({message: ErrorConsts.INVALID_TOKEN, uiRefs: ["token"]});
                            break;
                        case 'INVALID_EMAIL':
                            action.error = new ForgeError({message: ErrorConsts.EMAIL_INVALID, uiRefs: ["email1", "email2"]});
                            break;
                        case 'ALREADY_REGISTERED':
                            action.error = new ForgeError({message: ErrorConsts.EMAIL_ALREADY_REGISTERED, uiRefs: ["email1", "email2"]});
                            break;
                        case 'NO_EMAIL':
                            action.error = new ForgeError({message: ErrorConsts.MISSING_PARAMS, uiRefs: ["email1", "email2"]});
                            break;
                        case 'INVALID_CAPTCHA':
                            action.error = new ForgeError({message: ErrorConsts.INVALID_CAPTCHA, uiRefs: []});
                            break;
                        default:
                            action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
                    }
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL});
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onSignUpCompleted: function(actionID, res) {
        action = {};
        action.id = actionID;
        action.message = "Registration email sent."

        this.emitStatus();
    }

});

module.exports = SignUpStore;
